import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  display: flex;
  width: fit-content;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledButtonWrapper = styled.div``;
